import H_act from '@/helpers/act';
import H_time from '@/helpers/time';
import H_file from '@/helpers/file';
import H_common from '@/helpers/common';
import H_guidelineVersion from '@/helpers/guidelineVersion';
import H_guidelineVersionAdmin from '@/helpers/guidelineVersionAdmin';

export default {
  setList(rawDataList, config) {
    const {currentGuidelineVerId, scope, isGuidelineReleased, isGuidelineLastVersion} = config;
    const {scopeCreate, scopeUpdate, scopeDelete, scopeTaskCreate} = scope;
    return rawDataList.map(({
      id,
      sequence,
      parent_article_version_id: parentId,
      type,
      announce_at,
      effect_at,
      name,
      guideline_version: {id: guidelineVerId},
      guideline_article: {id: articleId},
      has_related_models,
    }) => {
      const isCreatedInCurrentGuidelineVer = guidelineVerId === currentGuidelineVerId;
      const customBtnList = [];
      if (scopeCreate && isGuidelineLastVersion) {
          customBtnList.push({
          icon: 'icon-add',
          event: 'create',
          tooltipText: '新增',
        });
      }
      if (scopeUpdate) {
        customBtnList.push({
          icon: 'icon-edit-pencil',
          event: 'update',
          tooltipText: '編輯',
        });
      }
      if (scopeCreate && !isGuidelineReleased && isGuidelineLastVersion && !isCreatedInCurrentGuidelineVer) {
        customBtnList.push({
          icon: 'icon-refresh',
          event: 'createVersion',
          tooltipText: '新立新版本',
        });
      }
      if (scopeTaskCreate && isGuidelineLastVersion) {
        customBtnList.push({
          icon: 'icon-nav-assignment-filled',
          event: 'createTask',
          tooltipText: '建立任務',
        });
      }
      if (scopeDelete && has_related_models !== 1) {
        customBtnList.push({
          icon: 'icon-delete',
          event: 'delete',
          color: 'red',
          tooltipText: '刪除',
        });
      }
      const chipList = isCreatedInCurrentGuidelineVer
        ? [{
            text: '更新'
          }]
        : [];
      const baseData = {
        id,
        name,
        sequence,
        type,
        announceAt: H_time.getDateDashFormat(announce_at),
        effectAt: H_time.getDateDashFormat(effect_at),
        parentId,
        isCollapsable: true,
        customBtnList,
        chipList,
        isLoading: false,
        articleId,
      };
      return baseData;
    })
  },
  setUpdate({
    act_version_alls,
    article_versions,
    announce_at,
    effect_at,
    content,
    effects,
    factory_effects,
    guideline_article: {id: articleId},
    guideline_version: {id: guidelineVerId},
    id,
    name,
    no_text: noText,
    parent_article_version_id: parentId,
    rich_content,
    sequence,
    type,
    guideline_status,
    attaches,
    related_guidelines,
  }) {
    return {
      id,
      parentId,
      articleId,
      guidelineVerId,
      sequence,
      type,
      name,
      noText,
      lawList: H_common.setLawList({act_version_alls, article_versions}),
      announceAt: H_time.getDateDashFormat(announce_at),
      effectAt: H_time.getDateDashFormat(effect_at),
      content: content ? content : '',
      richContent: rich_content ? H_common.formatRichContent(rich_content) : '',
      effects: [
        effects.map(effect => effect.id),
        factory_effects.map(effect => effect.id),
      ],
      guidelineStatus: guideline_status && guideline_status.id ? guideline_status.id : '',
      attaches: H_file.setShowInModule(attaches),
      guidelineList: H_guidelineVersionAdmin.setUpdateRelatedGuideline(related_guidelines),
    };
  },
  setEditSubmit({
    type,
    name,
    announceAt,
    effectAt,
    attaches,
    effects,
    guidelineStatus: guideline_status = '',
    lawList,
    content = '',
    richContent: rich_content = '',
    guidelineList,
  }) {
    const { actVersionAlls: act_version_alls, articleVersions: article_versions } = H_common.setSubmitActAndArticle(lawList);
    return {
      name,
      type,
      announce_at: H_time.getDateDashFormat(announceAt, 'YYYY-MM-DD HH:mm:ssZ'),
      effect_at: H_time.getDateDashFormat(effectAt, 'YYYY-MM-DD HH:mm:ssZ'),
      content,
      rich_content,
      reference_link: '',
      no_text: name,
      guideline_status,
      attaches: H_file.setSubmitInModule(attaches),
      factory_effects: effects[1] ? effects[1] : [],
      effects: effects[0] ? effects[0] : [],
      article_versions,
      act_version_alls,
      related_guidelines: H_guidelineVersionAdmin.setSubmitRelatedGuideline(guidelineList),
    };
  },
  setShow({
    act_version_alls,
    article_versions,
    announce_at,
    effect_at,
    content,
    effects,
    factory_effects,
    guideline_article: {id: articleId, has_versions: hasVersions},
    guideline_version: {id: guidelineVerId},
    id,
    name,
    no_text: noText,
    parent_article_version_id: parentId,
    rich_content,
    sequence,
    type,
    guideline_status: guidelineStatus,
    attaches,
    related_guidelines,
    has_audit,
    has_checklist,
    has_guideline_article_version,
    has_guideline_version,
    has_internal_training,
    has_license,
    has_task,
  }) {
    return {
      id,
      parentId,
      articleId,
      guidelineVerId,
      sequence,
      type,
      name,
      noText,
      lawCardList: H_guidelineVersion.setLawCardList({act_version_alls, article_versions}),
      announceAt: H_time.getDateDashFormat(announce_at),
      effectAt: H_time.getDateDashFormat(effect_at),
      content: content ? content : '',
      richContent: rich_content ? H_common.formatRichContent(rich_content) : '',
      effects: [
        ...effects,
        ...factory_effects,
      ].map(item => ({...item, color: 'red'})),
      guidelineStatus,
      attaches: H_file.setShowInModule(attaches),
      hasVersions,
      isLoading: false,
      guidelineList: H_guidelineVersionAdmin.setShowRelatedGuideline(related_guidelines),
      hasRelatedDoc: H_act.hasRelatedDoc({
        has_audit,
        has_checklist,
        has_guideline_article_version,
        has_guideline_version,
        has_internal_training,
        has_license,
      }),
      has_audit,
      has_checklist,
      has_guideline_article_version,
      has_guideline_version,
      has_internal_training,
      has_license,
      has_task,
    };
  },
  setCreateVerSubmit({
    type,
    name,
    announceAt,
    effectAt,
    attaches,
    effects,
    guidelineStatus: guideline_status = '',
    lawList,
    content = '',
    richContent: rich_content = '',
    sequence,
    parentId: parent_article_version,
    guidelineList,
  }, guidelineId, guidelineVerId) {
    const { actVersionAlls: act_version_alls, articleVersions: article_versions } = H_common.setSubmitActAndArticle(lawList);
    return {
      name,
      type,
      announce_at: H_time.getDateDashFormat(announceAt, 'YYYY-MM-DD HH:mm:ssZ'),
      effect_at: H_time.getDateDashFormat(effectAt, 'YYYY-MM-DD HH:mm:ssZ'),
      content,
      rich_content,
      reference_link: '',
      sequence,
      parent_article_version,
      no_text: name,
      guideline: guidelineId,
      guideline_version: guidelineVerId,
      guideline_status,
      attaches: H_file.setSubmitInModule(attaches),
      factory_effects: effects[1] ? effects[1] : [],
      effects: effects[0] ? effects[0] : [],
      article_versions,
      act_version_alls,
      related_guidelines: H_guidelineVersionAdmin.setSubmitRelatedGuideline(guidelineList),
    };
  },
  setCard(rawDataList) {
    return rawDataList.map(({
      id,
      name,
      type,
      announce_at,
      guideline: {id: guidelineId},
      guideline_version: {id: guidelineVerId},
    }) => {
      return {
        id,
        title: `${name}${announce_at ? ` (${H_time.getDateDashFormat(announce_at)})` : ''}`,
        type,
        guidelineId,
        guidelineVerId,
        articleVerId: id,
      }
    })
  }
}